(function ($) {
  Drupal.behaviors.mpp_alt_images = {
    attach: function (context, settings) {
      // use alternative images if MPP has #use-alt-images
      if( $('#use-alt-images').length ) {
        // replace on PC MPP
        $('.mpp__product').each(function() {
          var backgroundImg = $(this).find('.product_brief__image').attr('style');
          var productImage = backgroundImg.substring(57, 80);
          if ($('body').hasClass('ie')) {
            var productImage = backgroundImg.substring(58, 81);
          }
          var newBgImg = 'background-image:url(\'/media/export/cms/mpp/alternative-images/' + productImage + '_custom.jpg\')';
          $(this).find('.product_brief__image').attr('style', newBgImg);
        });
        // replace on Mobile MPP
        $('.device-mobile .mpp__product-grid .product-brief').each(function() {
          var backgroundImg = $(this).find('.product-brief__image').attr('style');
          var productImage = backgroundImg.substring(57, 80);
          var newBgImg = 'background-image:url(\'/media/export/cms/mpp/alternative-images/' + productImage + '_custom.jpg\')';
          $(this).find('.product-brief__image').attr('style', newBgImg);
        });
      }
    }
  };
})(jQuery);
